export default "__VITE_ASSET__ca9bd654__"